<div
  class="box-border flex items-center justify-center min-h-screen px-4 overflow-x-hidden bg-center bg-no-repeat page-bg"
>
  <div class="card max-w-[370px] w-full mx-auto box-border">
    <form
      [formGroup]="resetPasswordForm"
      (ngSubmit)="resetPassword($event, resetPasswordForm.value)"
      class="box-border flex flex-col gap-5 p-10 overflow-hidden card-body"
      id="reset_password_enter_email_form"
    >
      <!-- User ID Display - Only show if user came from reset password link (has query params) -->
      <div *ngIf="hasQueryParams && userId" class="text-center">
        <span class="font-medium text-gray-600 text-2sm"
          >Resetting password for user:
          <strong>{{ getMaskedUserId() }}</strong></span
        >
      </div>

      <!-- Old Password - Only show if user is logged in (no query params) -->
      <div *ngIf="!hasQueryParams" class="relative">
        <span class="block mb-1 font-medium text-gray-600 text-2sm"
          >Current Password</span
        >
        <input
          type="password"
          class="w-full max-w-full input"
          id="oldPassword"
          formControlName="oldPassword"
        />
        <div
          *ngIf="resetPasswordForm.get('oldPassword')?.touched && resetPasswordForm.get('oldPassword')?.errors?.['required']"
          class="mt-1 text-sm text-red-500"
        >
          Current password is required
        </div>
      </div>

      <!-- New Password -->
      <div class="relative">
        <span class="block mb-1 font-medium text-gray-600 text-2sm"
          >New Password</span
        >
        <input
          minlength="10"
          maxlength="25"
          [type]="showPassword ? 'text' : 'password'"
          class="w-full max-w-full pr-10 input"
          id="password"
          formControlName="password"
          (input)="checkPassword()"
        />
        <button
          type="button"
          (click)="togglePasswordVisibility('password')"
          class="absolute text-gray-500 right-3 top-9 hover:text-gray-800"
        >
          <i
            [ngClass]="
              showPassword ? 'ki-outline ki-eye' : 'ki-outline ki-eye-slash'
            "
          ></i>
        </button>
      </div>

      <!-- Confirm Password -->
      <div class="relative">
        <span class="block mb-1 font-medium text-gray-600 text-2sm"
          >Confirm Password</span
        >
        <input
          minlength="4"
          maxlength="25"
          [type]="showConfirmPassword ? 'text' : 'password'"
          class="w-full max-w-full pr-10 input"
          id="confirmPassword"
          formControlName="confirmPassword"
        />
        <button
          type="button"
          (click)="togglePasswordVisibility('confirmPassword')"
          class="absolute text-gray-500 right-3 top-9 hover:text-gray-800"
        >
          <i
            [ngClass]="
              showConfirmPassword
                ? 'ki-outline ki-eye'
                : 'ki-outline ki-eye-slash'
            "
          ></i>
        </button>
        <em
          *ngIf="resetPasswordForm.controls['confirmPassword'].errors?.['mustMatch']"
          class="block mt-1 text-sm text-red-500"
        >
          Passwords must match
        </em>
      </div>

      <!-- Action Buttons -->
      <div class="flex flex-wrap w-full gap-3 mt-2">
        <!-- Back Button (only when no query params and user is authenticated) -->
        <!--         <button *ngIf="!hasQueryParams && isAuthenticated" type="button" class="flex-1 min-w-0 btn btn-outline-secondary" (click)="navigateToDashboard()">
          <i class="ki-duotone ki-arrow-left me-1"></i> Back to Dashboard
        </button> -->
        <!-- Submit Button -->
        <button
          type="submit"
          class="justify-center flex-1 min-w-0 btn btn-primary"
          [disabled]="resetPasswordForm.invalid || isLoading || showSuccess"
          [class.disabled]="
            resetPasswordForm.invalid || isLoading || showSuccess
          "
        >
          <span *ngIf="!isLoading && !showSuccess">
            Reset Password <i class="ml-2 ki-filled ki-black-right"></i>
          </span>
          <span *ngIf="isLoading && !showSuccess" class="flex items-center">
            <i class="mr-2 ki-duotone ki-loading spin"></i> Processing...
          </span>
          <span *ngIf="showSuccess" class="flex items-center">
            <i class="mr-2 ki-duotone ki-check"></i> Success! Redirecting...
          </span>
        </button>
      </div>

      <!-- Success/Error -->
      <div *ngIf="showSuccess" class="text-xs text-green-800">
        <div class="flex flex-col items-center gap-2">
          <span *ngIf="hasQueryParams">Password reset successful.</span>
          <span *ngIf="!hasQueryParams">Password changed successfully.</span>
          <div *ngIf="redirectCountdown > 0" class="flex items-center gap-2">
            <i class="ki-duotone ki-loading spin"></i>
            <span *ngIf="hasQueryParams"
              >Redirecting to login in {{ redirectCountdown }} seconds...</span
            >
            <span *ngIf="!hasQueryParams"
              >Redirecting to dashboard in
              {{ redirectCountdown }} seconds...</span
            >
          </div>
        </div>
      </div>
      <div *ngIf="showError" class="text-xs text-red-800">
        {{ errorMessage }}
      </div>
      <!-- Password Feedback -->
      <div class="mt-2 text-sm text-red-500">
        <div>
          <span
            class="block"
            [ngClass]="{
              'text-green-500': hasMinLength,
              'text-red-500': !hasMinLength
            }"
          >
            Must be at least 10 characters
          </span>
          <span
            class="block"
            [ngClass]="{
              'text-green-500': hasUppercase,
              'text-red-500': !hasUppercase
            }"
          >
            At least one uppercase letter
          </span>
          <span
            class="block"
            [ngClass]="{
              'text-green-500': hasLowercase,
              'text-red-500': !hasLowercase
            }"
          >
            At least one lowercase letter
          </span>
          <span
            class="block"
            [ngClass]="{
              'text-green-500': hasDigit,
              'text-red-500': !hasDigit
            }"
          >
            At least one digit
          </span>
          <span
            class="block"
            [ngClass]="{
              'text-green-500': hasSpecialChar,
              'text-red-500': !hasSpecialChar
            }"
          >
            At least one special character
          </span>
          <span class="block text-black dark:text-white">
            Password cannot be a previous password
          </span>
        </div>
      </div>
    </form>
  </div>
</div>
